import styled from 'styled-components';
import { space } from 'styles/variables';
import Button from '@chownow/cocina-react-button';

export const StyledButton = styled(Button)`
  margin-top: ${space.x3};
  width: 100%;
`;
